// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"NoContentBlock_wrapper___Yn10","icon":"NoContentBlock_icon__3FL3N"};